import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import { DETAIL_ACTIONS } from "../../../../../../constants/Define";
import { useTranslation } from "react-i18next";
import ListSupplier from "../ListSupplier";
import classNames from "classnames";

const defaultCollapseKey = "campaignUseHotel";

function UseSupplierSection(props) {
  const {
    campaign,
    validation,
    action,
    setCampaign,
    getSupplierAll,
    getListRates,
    supplierState,
  } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  useEffect(() => {
    const hasError = validation && validation.productValues
    if (hasError && !collapseKey) {
      setCollapseKey(defaultCollapseKey);
    }
  }, [validation])

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  const onChangeProductList = (supplierIds, productIds) => {
    if (supplierIds && supplierIds.length > 0 && productIds && productIds.length > 0){
      const productValues = [];
      supplierIds.map(itemSupplier => {
        const existedSupplierObj = productValues.filter(item => {
          return item.id === itemSupplier;
        });
        if (
          itemSupplier &&
          (!existedSupplierObj || (existedSupplierObj && existedSupplierObj.length <= 0))
        ) {
          const productObj = {
            supplierId: itemSupplier,
            productIds: []
          };
          const arrProductIds = [];
          productIds.map(itemProductCode => {
            if (itemProductCode) {
              const arrProductCode = itemProductCode.split(":");
              if (arrProductCode && arrProductCode.length > 0) {
                const supplierId = arrProductCode[0];
                const productId = arrProductCode[1];
                if (supplierId === itemSupplier && !arrProductIds.includes(productId)) {
                  arrProductIds.push(productId);
                }
              }
            }
          });
          productValues.push({
            ...productObj,
            productIds: arrProductIds
          });
        }
      });

      setCampaign({
        ...campaign,
        productValues: {
          ...campaign.productValues,
          details: productValues,
          totalProducts: productIds.length
        }
      });
    } else {
      setCampaign({
        ...campaign,
        productValues: {
          ...campaign.productValues,
          productValues: [],
          totalProducts: productIds.length
        }
      });
    }
  };

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.skuIds")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"campaign-collapse-row"}>
          <div
            className={classNames(`col-md-12`, {
              "border-red": !!validation.productValues?.messageError
            })}
            style={{
              paddingTop: !!validation.productValues?.messageError && '1rem'
            }}
          >
            <Wrapper>
              <FormWrapperInputComponent
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <ListSupplier
                  getSupplierAll={getSupplierAll}
                  getListRates={getListRates}
                  allSuppliers={supplierState.supplierAll}
                  onChange={(supplierIds, productIds) =>
                    onChangeProductList(supplierIds, productIds)
                  }
                  action={action}
                  productsData={campaign?.productValues}
                />

                {!!validation.productValues && (
                  <span
                    className="text-red"
                    style={{
                      marginLeft: '5px'
                    }}
                  >
                    * {validation.productValues.messageError || ""}
                  </span>
                )}

                {campaign?.productValues?.totalProducts &&
                  parseInt(campaign?.productValues?.totalProducts) > 0 ? (
                  <span className="ml-2">
                    {`${t(`item.campaign.selectedRateCodes`)} ${campaign?.productValues?.totalProducts
                      } ${t(`item.campaign.selectedProductSuffix`)}`}
                  </span>
                ) : (
                  ""
                )
                }
              </FormWrapperInputComponent>
            </Wrapper>
          </div>
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

UseSupplierSection.propTypes = {
  campaign: PropTypes.object,
  supplierState: PropTypes.object,
  action: PropTypes.string,
  setCampaign: PropTypes.func,
  getSupplierAll: PropTypes.func,
  getListRates: PropTypes.func,
};

UseSupplierSection.defaultProps = {
  campaign: {},
  supplierState: {},
  action: "",
  setCampaign: () => {},
  getSupplierAll: () => {},
  getListRates: () => {},
};

export default UseSupplierSection;
